import { addUrlHashParam } from "../../../system/functions/url/add-url-hash-value";
import { LocationZoomSettings } from "../../models/map-settings";

/**
 * Adds the map settings to the url.
 * 
 * Here is an example of some map settings.
 * {
	lat: 30.282980792558224,
	lng: -81.50201203124999,
	zoom: 10,
	radius: 60000,
};
 * @param url The url to add the map settings to.
 * @param mapSettings The map settings to add to the passed in url.
 * @returns The passed in url with the map settings added, it will look something like this https://www.drhorton.com/texas/austin#mlat=30.282980792558224&mlng=-81.50201203124999&mzml=10&mrad=60000
 */
export const addMapParamsToUrl = (
	url: URL,
	mapSettings: LocationZoomSettings,
): URL => {
	if (mapSettings === null || mapSettings === undefined) {
		return url;
	}
	var urlParamString = "";

	url = addUrlHashParam(url, "mlat", mapSettings.lat.toString());
	url = addUrlHashParam(url, "mlng", mapSettings.lng.toString());
	url = addUrlHashParam(url, "mzml", mapSettings.zoom.toString());
	url = addUrlHashParam(url, "mrad", mapSettings.radius.toString());

	return url;
};
